// extracted by mini-css-extract-plugin
export default {"content":"success-screen_content__RKAoN","title":"success-screen_title__8firv","subtitle":"success-screen_subtitle__b1KLk","button":"success-screen_button__XearE"};